import React from "react";
import { Download } from "lucide-react";
import LeadDialog, { DOCS } from "@/components/forms/LeadDialog";

export default function BrochureFab() {
  return (
    <div className="fixed bottom-5 left-5 z-40">
      <LeadDialog
        formType="brochure"
        title="Download the Forum Brochure"
        description="Programme, expo, sponsorship & rates — instant PDF download."
        ctaLabel="Get the brochure"
        successMsg="Sent. Your download is starting now."
        downloadUrl={DOCS.brochure.url}
        downloadName={DOCS.brochure.name}
        trigger={
          <button
            data-testid="brochure-fab"
            className="group inline-flex items-center gap-2 rounded-full bg-ethanolOrange px-5 py-3.5 text-sm font-bold text-navy shadow-[0_10px_35px_rgba(194,240,60,0.45)] transition-all duration-300 hover:-translate-y-0.5 hover:bg-orangeDeep"
          >
            <Download className="h-4 w-4" />
            <span className="hidden sm:inline">Download Brochure</span>
            <span className="sm:hidden">Brochure</span>
          </button>
        }
      />
    </div>
  );
}
